// extracted by mini-css-extract-plugin
export default {"table":"EntityTable_table__D4p9f","disabled":"EntityTable_disabled__LgEwS"};